import React from "react";
import Slider from "react-slick";
import { Container } from "react-bootstrap";
import EventSliderCard from "../EventSliderCardV2/EventSliderCardV2";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { ContentSliderCss } from "./ContentSliderCss";
import "./ContentSlider.css";

interface ContentSliderI {
  title: string;
  data: any[] | undefined;
  event: boolean;
  type: string;
  sport?: string;
  style?: object;
}

const settings = (data: any) => {
  return ({
    dots: false,
    infinite: data < 6 ? false : true,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: false,
    prevArrow: (
      <button type="button" className="slick-prev">
        <i className="zmdi zmdi-chevron-left"></i>{" "}
      </button>
    ),
    nextArrow: (
      <button
        type="button"
        className="slick-next"
        style={ContentSliderCss.arrows}
      >
        <i className="zmdi zmdi-chevron-right"></i>
      </button>
    ),
    style: { margin: "0 -15px" },
    responsive: [
      {
        breakpoint: 1365,
        settings: {
          slidesToShow: 5
        }
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 479,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  })

};

const ContentSlider = (data: ContentSliderI) => {
  return (
    <div
      className="contentSlider-main"
      style={{
        ...data.style,
        paddingTop: "50px",
        backgroundColor: "#000000",
      }}
    >
      <Container fluid style={{ padding: "0 50px", minHeight: data.data && data.data.length < 1 ? "120px" : "220px" }}>
        <div style={{ borderBottom: "1px solid #444", margin: "0 0 30px" }}>
          <h2
            className="section-title-4"
            style={{
              fontSize: "24px",
              color: "#ffffff",
              margin: "0",
              fontWeight: "bold",
              padding: "0 0 15px",
              textTransform: "capitalize"
            }}
          >
            {data.title}
          </h2>
        </div>
        {data.data && data.data.length < 1 && (
          <>
            <p style={{ position: "absolute" }}>
              There is no data available at the moment
            </p>
          </>
        )}
        <Slider {...settings(data?.data && data?.data?.length)} className="contentSlider">
          {data?.data?.map((event, index) => (
            <EventSliderCard
              key={index}
              title={event?.name ?? event?.event?.name}
              imageUrl={event?.images[2]?.url ?? event?.event?.images[2]?.url}
              date={event.startTime}
              league={
                event?.competition?.name ?? event?.event?.competition?.name
              }
              teams={event?.teams ?? event?.event?.teams}
              event={data.event}
              sport={data.sport}
              competitionLogo={event?.competition?.images[0]?.url}
              uuid={event?.uuid}
              url={`/${data.type}/${event?.uuid}`}
            />
          ))}
        </Slider>
      </Container>
    </div>
  );
};

export default ContentSlider;
